import config from '../../../config';
import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../../constants';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import BaseMfaVerifyOieCustomizer from './base';

const { oieEnabled } = config;

export default class ChallengeAuthenticatorOieCustomizer extends BaseMfaVerifyOieCustomizer {
  primaryButtonClassName = 'fe_u_margin--bottom-small';

  primaryButtonOnClick = () => {
    AmplitudeUtils.logMfaChallengeEvent(`${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}::VerifyButtonClick`);
  };

  async shouldCustomize() {
    return this.context.controller === 'mfa-verify' && this.context.formName === 'challenge-authenticator' && oieEnabled;
  }

  emitAmplitudeLandingEvent() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
  }

  protected forgifyController() {
    this.emitAmplitudeLandingEvent();
    super.forgifyController();
  }

}
